import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { Card, CardContent } from "../components/ui/card";
import { GraduationCap, Briefcase } from 'lucide-react';

const About = () => {
  useEffect(() => {
    document.title = 'Internjin | About Us';
  }, []);

  return (
    <Layout>
      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-slate-900 mb-6">About Internjin</h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              We are building the ultimate bridge between European talent and Japanese innovation.
            </p>
          </div>

          <div className="prose prose-slate max-w-none mb-20">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Our Mission</h2>
            <p className="text-slate-600 mb-8">
              Internjin was born from a simple observation: Japan faces a critical talent shortage, while French students are eager for international experience but often lack the access to the Japanese market. We exist to solve both problems simultaneously by creating a streamlined, supported pathway for elite internships.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  PT
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">P. Theotime</h3>
                <p className="text-red-600 font-medium mb-6">Co-Founder</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>Master in Robotics (CPE Lyon)</p>
                  <p>Ex-Intern at BMW Japan (Tokyo)</p>
                </div>
              </CardContent>
            </Card>

            <Card className="border-none shadow-lg bg-white">
              <CardContent className="p-8 flex flex-col items-center text-center">
                <div className="h-24 w-24 bg-slate-200 rounded-full flex items-center justify-center mb-6 text-2xl font-bold text-slate-600">
                  DC
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-1">D. Chahan</h3>
                <p className="text-red-600 font-medium mb-6">Co-Founder</p>
                <div className="text-slate-600 text-sm space-y-2">
                  <p>Master in Robotics (CPE Lyon)</p>
                  <p>Ex-Intern at Sound & Vision (Osaka)</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
